import { AxiosResponse } from 'axios'
import { api } from '../../api'

export type CreatePartnerRequest = {
  name: string
  document: string
  documentType: string
  email: string
  phoneNumber: string
  address: {
    zipCode: string
    complement?: string
    country: string
    state: string
    city: string
    street: string
    district: string
    number: number
  }
}

export type CreateBankAccountPartner = {
  bank: string
  bankAg: string
  bankCc: string
  bankAccountType: string
}

export type CreatePartnerResponse = {
  id: string
  name: string
  document: string
  documentType: 'CPF' | 'CNPJ'
  email: string
  phoneNumber: string
  address: {
    country: string
    state: string
    city: string
    street: string
    district: string
    number: number
    zipCode: string
    complement?: string
  }
  createdAt: string
  updatedAt: string | null
  bank: string
  bankAg: string
  bankCc: string
  bankAccountType: string
}

export const createPartnerService = async (
  request: CreatePartnerRequest,
  requestBank: CreateBankAccountPartner,
  creatorId: string
) => {
  const { data }: AxiosResponse<CreatePartnerResponse> = await api.post(
    `/api/backoffice/creators/${creatorId}/partners`,
    request
  )

  const response: AxiosResponse<CreatePartnerResponse> = await api.post(
    `/api/backoffice/partners/${data.id}/verification`,
    requestBank
  )

  return response.data
}
